import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
    editUserConfig,
    getUserConfig,
    getUserConfigData,
    changeCampaignsFilter,
    getcampaignTableMetrics,
    changeBigNumbers,
} from './user-config.state';

export const withUserConfig = connect(
    state => ({
        userConfig: getUserConfigData(state),
        campaignTableMetrics: getcampaignTableMetrics(state),
    }),
    dispatch => bindActionCreators({
        getUserConfig,
        editUserConfig,
        changeBigNumbers,
        changeCampaignsFilter,
    }, dispatch),
);
